import { UNKNOWN_ERROR } from "../messages/errorsMessages";
import { ApiResult } from "../models/ApiResult";
import { dispatchAlerts, onErroredResponse } from "../api/responseConverters";

export default async (
  throwableFunction: Function,
  onSuccess: Function,
  dispatch: Function,
  onFinish: Function = () => {},
  onError: Function = () => {}
) => {
  let response: ApiResult = {} as ApiResult;
  try {
    response = await throwableFunction();
    if (response.isError) {
      onErroredResponse(response.errorTable, dispatch);
      onError();
    } else {
      onSuccess(response.result);
      dispatchAlerts(response, dispatch);
    }
  } catch (error) {
    console.log(error);
    onErroredResponse([UNKNOWN_ERROR], dispatch);
    onError();
  } finally {
    onFinish();
  }
  return !response.isError;
};
